import { Injectable } from '@angular/core';

import { AccaBoostToken } from '../../reward-tokens.model';
import { AccaBoostNotABetBuilderPickValidator } from './criteria/acca-boost-not-a-bet-builder-pick-validator.service';
import { AccaBoostBetslipTypeStateValidator } from './criteria/acca-boost/acca-boost-betslip-type-state-validator.service';
import { AccaBoostCompetitionsValidator } from './criteria/acca-boost/acca-boost-competitions-validator.service';
import { AccaBoostGridGroupsValidator } from './criteria/acca-boost/acca-boost-grid-groups-validator.service';
import { AccaBoostMinOddsValidator } from './criteria/acca-boost/acca-boost-min-odds-validator.service';
import { AccaBoostMinimumLegsValidator } from './criteria/acca-boost/acca-boost-minimum-legs-validator.service';
import { AccaBoostSlipTypeValidator } from './criteria/acca-boost/acca-boost-slip-type-validator.service';
import { AccaBoostSportsValidator } from './criteria/acca-boost/acca-boost-sports-validator.service';
import { BetslipTypeStateValidator } from './criteria/betslip-type-state-validator.service';
import { DayOfWeekValidatorService } from './criteria/day-of-week-validator.service';
import { ExpiryDateValidator } from './criteria/expiry-date-validator.service';
import { GameTypeValidator } from './criteria/game-type-validator.service';
import { NotEachWayValidator } from './criteria/not-each-way-validator.service';
import { TeaserRewardTypeValidator } from './criteria/teaser-reward-type-validator.service';
import { TokenValidator } from './token-validator.service';

@Injectable()
export class AccaBoostTokenValidator extends TokenValidator<AccaBoostToken> {
    constructor(
        sportValidator: AccaBoostSportsValidator,
        gameTypeValidator: GameTypeValidator,
        accaBoostMinimumLegsValidator: AccaBoostMinimumLegsValidator,
        slipTypeValidator: AccaBoostSlipTypeValidator,
        minOddsValidator: AccaBoostMinOddsValidator,
        marketsValidator: AccaBoostGridGroupsValidator,
        competitionValidator: AccaBoostCompetitionsValidator,
        expiryDateValidator: ExpiryDateValidator,
        daysOfWeekValidator: DayOfWeekValidatorService,
        teaserRewardTypeValidator: TeaserRewardTypeValidator,
        notEachWayValidator: NotEachWayValidator,
        notBetBuilderBetValidator: AccaBoostNotABetBuilderPickValidator,
        accaBoostBetslipTypeStateValidator: AccaBoostBetslipTypeStateValidator,
        betslipTypeStateValidator: BetslipTypeStateValidator,
    ) {
        super();

        /**
         * Ensures that the betslip type is combo bet
         */
        this.hardCriteriaValidators.push(slipTypeValidator);

        /**
         * AccaBoostBetslipTypeStateValidator ensures 'selectedPicks' is non-empty array;
         * Multiple validators omit check for 0-length and validation will pass on empty picks array.
         * This only checks if there is at least one pick, as other validators take precedence otherwise.
         */
        this.hardCriteriaValidators.push(accaBoostBetslipTypeStateValidator);
        this.hardCriteriaValidators.push(notEachWayValidator);
        this.hardCriteriaValidators.push(expiryDateValidator);
        this.hardCriteriaValidators.push(daysOfWeekValidator);
        this.hardCriteriaValidators.push(sportValidator);
        this.hardCriteriaValidators.push(notBetBuilderBetValidator);
        this.hardCriteriaValidators.push(competitionValidator);
        this.hardCriteriaValidators.push(marketsValidator);
        this.hardCriteriaValidators.push(minOddsValidator);
        this.hardCriteriaValidators.push(teaserRewardTypeValidator);
        this.hardCriteriaValidators.push(gameTypeValidator);

        /**
         *  AccaBoostMinimumLegsValidator has to be last but one to properly calculate eligbility for Acca Boost
         *  If everything else is valid, we use this validator to check if we can show One Leg Away message
         */
        this.hardCriteriaValidators.push(accaBoostMinimumLegsValidator);

        /**
         *  This catches any case where minimum legs isn't triggered but we still only have one pick
         */
        this.hardCriteriaValidators.push(betslipTypeStateValidator);

        this.softCriteriaValidators.push(accaBoostMinimumLegsValidator);

        /**
         * We need these soft criteria validators to check their validity even when slip type is not matching
         * This is needed for displaying the one leg away message
         */
        this.softCriteriaValidators.push(sportValidator);
        this.softCriteriaValidators.push(minOddsValidator);
    }
}
